export enum DeclarationStatusSource {
  engine = 'engine',
  sie = 'sie',
  gi = 'gi',
  accountant = 'accountant',
  client = 'client'
}
